import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import dataFetcher from "Parts/chore/dataFetcher";

import { activateCreationMode, deactivateCreationMode } from 'Parts/ui/uiActions';
import { fetchCountries, fetchProvinces } from 'Parts/geo/geoActions';
import { clearPurchase, cancelTransaction } from '../../eventActions';
import { fetchPlatformIdBySurveyList } from "../../../../../donation/donationActions";
import BuyTicketsPage from './BuyTicketsPage';

const mapStateToProps = state => ({
  locale: state.session.language,
  platform: get(state, 'platform.platform', {}),
  campaign: get(state, 'campaign.campaign', null),
  team: get(state, 'team.team', null),
  userTypeId: get(state, 'session.userTypeId', null),
  currentStep: get(state, 'Event.ticketsSaleWizardState', null),
  ticketsSaleWizardState: get(state, 'Event.ticketsSaleWizardState', null),
  ticketSelection: get(state, 'Event.ticketSelection', null),
  eventEndOn: get(state, 'Event.event.endOn', null),
  checkout: get(state, 'Event.checkout'),
  reserve: get(state, 'Event.reserve'),
  surveyId: state.donation.surveyId,
  surveysFields: state.surveyPage.surveysFields,
  participant: state.participant.participant
});

const mapDispatchToProps = dispatch => bindActionCreators({
  activateCreationMode,
  deactivateCreationMode,
  fetchCountries,
  fetchProvinces,
  clearPurchase,
  cancelTransaction,
  fetchPlatformIdBySurveyList,
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(BuyTicketsPage);
